export const PROMPT_MARKER_PATTERN = /\[[A-ZÀ-Ú0-9_ ]+\]/g;

export interface PromptMarker {
  name: string;
  label: string;
}

export type MarkerValues = Readonly<Record<string, string>>;

export function extractPromptMarkers(template: string): PromptMarker[] {
  const seen = new Set<string>();
  const markers: PromptMarker[] = [];

  for (const match of template.matchAll(PROMPT_MARKER_PATTERN)) {
    const name = match[0];
    if (!seen.has(name)) {
      seen.add(name);
      markers.push({ name, label: name.slice(1, -1) });
    }
  }
  return markers;
}

export function normalizedPromptValue(value: string | undefined): string {
  return value?.trim() ?? '';
}

export function applyPromptValues(template: string, values: MarkerValues): string {
  return template.replace(PROMPT_MARKER_PATTERN, (marker) => {
    const value = normalizedPromptValue(values[marker]);
    return value === '' ? marker : value;
  });
}

export function reconcilePromptValues(template: string, values: MarkerValues): Record<string, string> {
  const allowed = new Set(extractPromptMarkers(template).map((marker) => marker.name));
  return Object.fromEntries(Object.entries(values).filter(([marker]) => allowed.has(marker)));
}

export function filledPromptMarkerCount(markers: PromptMarker[], values: MarkerValues): number {
  return markers.filter((marker) => normalizedPromptValue(values[marker.name]) !== '').length;
}
